import {exists} from "./helpers.js";

/**
 * Build external NWS links from a facility's coordinates and cached weather source.
 *
 * @param {{lat?: number|string, lon?: number|string, weatherSource?: {stationId?: string}}} params
 * @returns {{provider: string, label: string, url: string}[]}
 */
export const getWeatherSourceLinks = ({lat, lon, weatherSource} = {}) => {
  const links = [];

  if (exists(lat) && exists(lon))
    links.push({
      provider: "nws",
      label: "NWS forecast",
      url: `https://forecast.weather.gov/MapClick.php?lat=${encodeURIComponent(
        lat
      )}&lon=${encodeURIComponent(lon)}`
    });

  if (exists(weatherSource?.stationId))
    links.push({
      provider: "nws",
      label: "Station readings",
      url: `https://www.weather.gov/wrh/timeseries?site=${encodeURIComponent(
        weatherSource.stationId
      )}`
    });

  return links;
};

/** Tooltip for live NWS pages shown alongside a stored observed reading. */
export const LIVE_WEATHER_SOURCE_TITLE =
  "Live forecast; may differ from last night's reading";

/** Tooltip for the live NWS forecast shown alongside a stored chance of rain. */
export const LIVE_FORECAST_SOURCE_TITLE =
  "Live forecast; may differ from this morning's reading";
